/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { StylesConfig } from '@atlaskit/select';
import { token } from '@atlaskit/tokens';

// @atlaskit/modal-dialog adds style rules for overflow to the css class generated by emotion here.
// Added !important to ensure these rules are followed over the ones added by @atlaskit.
export const ModalContainer = styled.div`
  overflow-x: visible !important;
  overflow-y: visible !important;
`;

// like ModalContainer but with extra padding to be compatible with the
// next version of atlaskit/modal-dialog (v12)
export const ModalContainerNext = styled.div`
  overflow-x: visible !important;
  overflow-y: visible !important;
  padding: ${token('space.025')} ${token('space.300')};
`;

export const FormContainer = styled.div({
  maxWidth: '420px',
});

export const SelectLabel = styled.div({
  font: token('font.body.UNSAFE_small'),
  fontWeight: token('font.weight.semibold'),
  color: token('color.text.subtlest'),
  display: 'inline-block',
  marginTop: '28px',
  marginBottom: token('space.050'),
});

export const NoticeContainer = styled.p({
  margin: `${token('space.200')} 0`,
});

export const SearchResultOption = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const OptionAvatar = styled.div({
  marginTop: '1px',
  marginRight: token('space.100'),
  width: token('space.300'),
  height: token('space.300'),
});

export const OptionName = styled.span({
  marginRight: token('space.100'),
});

export const SearchGroupOption = styled(SearchResultOption)({
  padding: '1px 0',
  '& > div': {
    background: token('color.background.accent.gray.subtler'),
    borderRadius: '50%',
    border: `${token('space.025')} solid ${token('color.border.inverse')}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});

export const HasAccessInfo = styled.span({
  marginLeft: 'auto',
  color: token('color.text.subtlest'),
  font: token('font.body.small'),
});

export const SelectDropdownContainer = styled.div<{ topMarginFactor?: number }>(
  {
    marginTop: `${({ topMarginFactor = 2 }) => 8 * topMarginFactor}px`,
    width: '360px',
  }
);

export function getModalSelectStyles<
  T extends { [key: string]: any },
  K extends boolean
>(options: {
  marginLeft?: number;
  maxWidth?: number;
  paddingBottom?: number;
}): StylesConfig<T, K> {
  const { marginLeft, maxWidth, paddingBottom } = options;
  const modalSelectStyles: StylesConfig<T, K> = {
    container: base => ({
      ...base,
      maxWidth: maxWidth || 420,
      marginLeft: marginLeft || 0,
      paddingBottom: paddingBottom || 0,
    }),
    menuPortal: base => ({
      ...base,
      zIndex: 9999,
    }),
    control: base => ({
      ...base,
      backgroundColor: token('color.background.accent.gray.subtlest'),
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      ...(state.data.isFixed ? { display: 'none' } : {}),
      ':hover': {
        backgroundColor: token('color.background.accent.gray.subtlest.hovered'),
      },
    }),
    multiValue: (base, state) => ({
      ...base,
      alignItems: 'center',
      height: token('space.300'),
      backgroundColor: state.data.isFixed
        ? token('color.background.accent.gray.subtlest.hovered')
        : token('color.background.accent.gray.subtlest'),
      paddingRight: state.data.isFixed ? 11 : base.paddingRight,
      paddingLeft: state.data.isFixed ? 7 : base.paddingLeft,
    }),
    multiValueLabel: (base, state) => ({
      ...base,
      color: state.data.isFixed ? token('color.text.inverse') : base.color,
    }),
  };
  return modalSelectStyles;
}

export const modalSelectStyles: StylesConfig<any, boolean> =
  getModalSelectStyles({
    maxWidth: 420,
  });
